"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { resolveParent, type RouteTable } from "./route-metadata";

export interface UseBackButtonOptions {
  /** Route table */
  routes: RouteTable;
  /** Current route's template (with `[param]` placeholders) */
  currentTemplate: string;
  /** Concrete params for substitution */
  params?: Record<string, string>;
}

export function useBackButton({ routes, currentTemplate, params }: UseBackButtonOptions) {
  const router = useRouter();
  const goBack = useCallback(() => {
    const parent = resolveParent(routes, currentTemplate, params);
    if (parent) {
      router.push(parent as never);
    } else {
      router.back();
    }
  }, [router, routes, currentTemplate, params]);
  return { goBack };
}
